import styled, {css} from 'styled-components'
import {ReactNode} from 'react'

export const StyledCheckBoxContainer = styled.div<{$label?: ReactNode}>`
    ${({theme: {spacing}, $label}) => css`
        display: flex;
        gap: ${$label ? spacing * 2 : 0}px;
    `}
`

export const StyledCheckBoxInputWrapper = styled.label<{$labelPosition: 'left' | 'right'}>`
    ${({theme: {spacing}, $labelPosition}) => css`
        display: flex;
        flex-direction: ${$labelPosition == 'right' ? 'row' : 'row-reverse'};
        width: max-content;
        max-width: 100%;
        gap: ${spacing}px;
        align-items: center;
    `}
`

export const StyledCheckBox = styled.input<{$invisible?: boolean}>`
    ${({theme: {palette, transition, spacing}, $invisible}) => css`
        width: ${spacing * 4}px;
        height: ${spacing * 4}px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid ${palette.neutral['300']};
        transition: ${transition};
        cursor: pointer;

        ${$invisible &&
        css`
            visibility: hidden;
            transition: none;
        `}

        &:checked {
            background: ${palette.primary['600']};
            border: 1px solid ${palette.primary['600']};
            content: ${`url("data:image/svg+xml,%3Csvg viewBox='-4 -4 18 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 4L4 7L9 1' stroke='${palette.neutral.white.replace(
                '#',
                '%23'
            )}' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");`};
        }

        &:disabled:checked {
            background: ${palette.neutral['100']};
            border: 1px solid ${palette.neutral['300']};
            cursor: not-allowed;
            content: ${`url("data:image/svg+xml,%3Csvg viewBox='-4 -4 18 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 4L4 7L9 1' stroke='${palette.neutral[
                '300'
            ].replace(
                '#',
                '%23'
            )}' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");`};
        }

        &:disabled {
            background: ${palette.neutral['100']};
            border: 1px solid ${palette.neutral['300']};
            cursor: not-allowed;
        }
    `}
`

export const StyledCheckBoxLabel = styled.label`
    ${({theme: {typography, palette}}) => css`
        ${typography.textSm};
        color: ${palette.primary['400']};
        & > a {
            text-decoration: underline;
            cursor: pointer;
        }
    `}
`
